var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.667 7.292v5.95c0 1.481-.49 2.73-1.365 3.593-.863.875-2.111 1.365-3.593 1.365v2.112c0 .793-.887 1.271-1.54.828l-1.132-.747c.105-.361.152-.758.152-1.178v-4.748c0-2.38-1.587-3.967-3.967-3.967H6.301c-.164 0-.315.012-.467.023V7.292c0-2.975 1.983-4.959 4.958-4.959h9.917c2.975 0 4.958 1.984 4.958 4.959Z",
    fill: "#F35508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.189 14.467v4.748c0 .42-.047.817-.152 1.178-.431 1.715-1.855 2.789-3.815 2.789H11.05l-3.523 2.345C7 25.888 6.3 25.503 6.3 24.873v-1.691c-1.19 0-2.182-.397-2.87-1.085-.7-.7-1.097-1.692-1.097-2.882v-4.748c0-2.217 1.377-3.745 3.5-3.944.152-.011.303-.023.467-.023h7.921c2.38 0 3.967 1.587 3.967 3.967Z",
    fill: "#F35508"
  })));
};
export default SvgChat;